import Image, { StaticImageData } from 'next/image'
import { FC, ReactNode, useState } from 'react'

import plusActive from '../../assets/plus-active.png'
import plus from '../../assets/plus-inactive.png'

import styles from './WhyCard.module.scss'

export type WhyCardProps = {
	iconSrc: StaticImageData
	iconSrcHover: StaticImageData
	iconAlt?: string
	title: string
	subtitle: string | ReactNode
}

export const WhyCard: FC<WhyCardProps> = ({ iconSrc, iconSrcHover, iconAlt = 'icon', title, subtitle }) => {
	const [isHovered, setIsHovered] = useState(false)

	return (
		<article className={`${styles.card} ${isHovered ? styles.hovered : ''}`}>
			<div className={styles.iconWrap} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
				<Image src={plus} alt={iconAlt} width={44} height={44} className={styles.bottomIcon} />
				<Image src={plusActive} alt={iconAlt} width={44} height={44} className={styles.bottomIconHover} />
			</div>
			<Image src={iconSrc} alt={iconAlt} width={80} height={80} className={styles.icon} />
			<Image src={iconSrcHover} alt={iconAlt} width={80} height={80} className={styles.hoverIcon} />
			<div className={styles.content}>
				<div className={styles.textWrap}>
					<h3 className={styles.title}>{title}</h3>
					<div className={styles.subtitle}>{subtitle}</div>
				</div>
			</div>
		</article>
	)
}
